// Copyright (c) 2025 Deere & Company

import RgaSearchResults from './rga-search-result';
import t from 'tcomb';

const RgaSelectedMassUpdateList = t.list(RgaSearchResults, 'RgaSearchResults');

export const getDefaultState = () => new RgaSelectedMassUpdateList([]);

export default RgaSelectedMassUpdateList;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-selected-mass-update-list.js